import React from 'react'
import { useAuthentication } from '@mcity/siauliai-core/src/components/providers'
import { Redirect } from 'react-router-dom'

export default function Logout() {
  const { logout } = useAuthentication()
  logout()
  return <Redirect to="/login" noThrow />
}
